// extracted by mini-css-extract-plugin
export default {"CardList":"index__CardList--uW9wg","cardList":"index__CardList--uW9wg","CardListNoTitle":"index__CardListNoTitle--+tt1a","cardListNoTitle":"index__CardListNoTitle--+tt1a"};